import SoftSelect from "components/SoftSelect";
import { components } from "react-select";

const StyledSelect = ({ ...props }) => {
  const SelectInput = (props) => <components.Input {...props} autoComplete="new-password" />;
  return (
    <SoftSelect
      className="soft-select-wrapper-I"
      menuPortalTarget={document.body}
      components={{ SelectInput }}
      classNamePrefix="soft-select"
      autoFocus
      required
      {...props}
    />
  );
};

export default StyledSelect;
